import React, {useState, useEffect, useContext, useRef} from 'react'
import "./header.css"
import {FaRegHeart } from 'react-icons/fa';
import {BiSearch} from 'react-icons/bi';
import {CgShoppingCart} from 'react-icons/cg';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import { PopupMenu } from "react-simple-widgets";
import imgg from "./images/52-modified.png"
import { Context1 } from '../../utils/auth';
import { Context } from '../../utils/context';
import Cart from '../Cart/Cart';
import Search from './Search/Search';
import { useNavigate } from 'react-router-dom';

// Header Function Starts here

function Header(props:any) {

  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor: any, open: any) => (event: any) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event.key === 'Tab' || event.key === 'Shift'))
    ) {
      return;
    }

    setState({ ...state, left: open });
  };

  const list = (anchor: any) => (
    
    <Box 
      sx={{ width: 250 , height: "100%"}}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List id="sidebar">
        <div id="acc-avatar-res" className="text-center mx-auto mb-4">
          <span>K</span>
        </div>
        <div className="sidebar-items">
          <ul className='sidebar-objects'>
            <li onClick={() => navigate("/")}>Home</li>
            <li>Featured</li>
            <li onClick={() => navigate("/shop")}>Shop</li>
            <li onClick={() => navigate("/")}>About</li>
            <li onClick={() => navigate("/")}>Contact</li>
            <li onClick={handleLogOut}>Log Out</li>
          </ul>
        </div>
      </List>
    </Box>
  );

  // Sticky Navbar TSX
  const [scrolled, setScrolled] = useState(false);
  const handleScroll = () => {
    const offset = window.scrollY;
    if(offset > 90){
      setScrolled(true);
    } else {
      setScrolled(false);;
    }
  }


  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
  }, []);
  

  const {name, email, logout, user, setUser, gAuth, setGAuth} = useContext(Context1);
  const username = props.userName || name;

  let stringVal = props.userEmail || email;
  
  let shortenString = stringVal.substring(0, 15).concat('...');

  const handleLogOut = () => {
    if(user){
      navigate("/login");
      setUser(false);
    }
    if(gAuth){
      setGAuth(false);
      window.open(`${process.env.REACT_APP_API}/auth/logout`, "_self");
    }
  }

  const {cartCount} = useContext(Context);

  //Cart Functionality
  const [showCart, setShowCart] = useState(false);
  const [showSearch, setShowSearch] = useState(false)


  const navigate = useNavigate();

  return (
    <>
      <header className={`main-header ${scrolled ? "sticky-header": ""}`}>
        <div className="header-content">
          <div className="nav-left"> 
            <div id='menu'>
              <Button onClick={toggleDrawer('left', true)}><MenuIcon id="menu-icon" style={{color: "white"}}/></Button>
              <SwipeableDrawer
                anchor="left"
                open={state.left}
                onClose={toggleDrawer('left', false)}
                onOpen={toggleDrawer('left', true)}
              >
                {list('left')}
              </SwipeableDrawer>
            </div>
            <div className="logo" onClick={() => navigate("/")}>Xiel Store</div>
            <ul className="nav-objects">
              <li onClick={() => navigate("/")}>Home</li>
              <li>Feature</li>
              <li onClick={() => navigate("/shop")}>Shop</li>
              <li onClick={() => navigate("/")}>About</li>
              <li onClick={() => navigate("/")}>Contact</li>
            </ul>
          </div>
          <div className="right" id='right'>
            <BiSearch onClick={() => setShowSearch(true)}/>
            <FaRegHeart />
            <span className="cart-icon" onClick={() => setShowCart(true)}>
              <CgShoppingCart />
              {!!cartCount && <span>{cartCount}</span>}
            </span>
            <PopupMenu>
              <img src={props.img || imgg} className="nav-img" />
              <div className="card text-start">
                <div className="card-body px-4 py-4">
                  <div id="acc-avatar" className="text-center mx-auto mb-4" style={{height:"80px", width:"80px"}}>
                    {props.img ? <img src={props.img} className="nav-img" alt="" /> : <img src={imgg} style={{height:"80px"}} className="nav-img" alt="" />}
                  </div>
                  <h5 className="text-center mb-0">{username}</h5>
                  <p className="text-center mb-2">{shortenString}</p>

                  <hr />

                  <div
                    className="list-group list-group-flush"
                    style={{ margin: "0 -24px 0" }}
                  >
                    <button className="list-group-item list-group-item-action px-4">
                      <small>Profile</small>
                    </button>
                    <button className="list-group-item list-group-item-action px-4">
                      <small>Notifications</small>
                    </button>
                    <button className="list-group-item list-group-item-action px-4">
                      <small>Other Requests</small>
                    </button>
                  </div>

                  <hr style={{ margin: "0 -24px 24px" }} />

                  <div className="d-grid">
                    <button className="btn btn-secondary" onClick={handleLogOut}>
                      <small>Logout</small>
                    </button>
                  </div>
                </div>
              </div>
            </PopupMenu>
          </div>
        </div>
      </header>
      {showCart && <Cart setShowCart={setShowCart}/>}
      {showSearch && <Search setShowSearch={setShowSearch}/>}
    </>
  )
}

export default Header
